import { Checkbox, Form, Radio } from 'antd';
import Collapse from '@mui/material/Collapse';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { changeTimeUnit, updateTimeSettings } from 'store/reducers/inputReducer';
import { selectTimeSetting } from 'store/reducers/selectors/settingsSelectors.js';

const TableUseTimeWindowsCheck = (props) => {
    const dispatch = useDispatch();
    const timePeriodSpansDays = useSelector(selectTimeSetting("timePeriodSpansDays"));

    const timeUnit = useSelector(selectTimeSetting("timeUnit"));

    const handleTimePeriodSpanChange = () => {
      dispatch(updateTimeSettings({settingNames:['timePeriodSpansDays'], tableName:props.tableName, settingValues: [!timePeriodSpansDays]}));
    }

    const handleTimeUnitChange = (e) => {
      dispatch(changeTimeUnit({newTimeUnit: e.target.value}));
    }

    return    <>
        <FormControl>
          <Form.Item label="Select time type">
              <Radio.Group
                      name="row-radio-buttons-group"
                      value={timeUnit}
                      onChange={handleTimeUnitChange}
                      options={[
                      { value: "clock", label: "Clock time (i.e. 11:00 am)" },
                      { value: "integer", label: "Integer (i.e. 660 minutes)" }
                      ]}
                  />
            </Form.Item>
        </FormControl>

        <Collapse in={timeUnit === 'clock'} unmountOnExit>
            <Stack direction="row" spacing={2}>
              <Form.Item label="Time periods span multiple days">
                <Checkbox
                  checked={Boolean(timePeriodSpansDays)}
                  onChange={handleTimePeriodSpanChange}
                />
              </Form.Item>
          </Stack>
        </Collapse>
  </>
}

export default TableUseTimeWindowsCheck;
